import React, { useState } from 'react';
import FeatureInputElements from './FeatureInputElements';
import FeatureContentElements from './FeatureContentElements';

const InfoSignalSource = ({ onSubmit }) => {
  const [settings, setSettings] = useState({
    fileURL: '',
  });

  const handleChange = (field, value) => {
    setSettings((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    onSubmit(settings);
  };

  return (
    <div className='border text-white border-gray-500 bg-gray-800 bg-opacity-85 rounded-lg w-48'>
      <h2 className='min-w-40 text-[0.4em] border-b border-gray-500 bg-gray-900 rounded-t-lg mb-1 py-0.5'>Signal Source</h2>
      <div className='text-left font-light px-1 text-[0.3em]'>
        <p>Ingested content is processed as follows...</p>

        <ol className="list-disc list-inside pl-2 space-y-2">
          <li className="pl-2 -indent-4">
            Transcoded into full ABR in HLS & DASH
          </li>
          <li className="pl-2 -indent-4">
            Encrypted with DRM
          </li>
          <li className="pl-2 -indent-4">
            Fairplay, Widevine, Playready, and much much more
          </li>
        </ol>      </div>
    </div>
  );
};

export default InfoSignalSource;